import React from "react";
import CLDetailsContainer from "./CLDetailsContainer";
import { Route, Switch } from "react-router-dom/cjs/react-router-dom";
import { DocumentTitle } from "../../components/DocumentTitle/DocumentTitle";


export const CLDetailsMain = function ({ match }) {
    return (
        <div className="column">
            <DocumentTitle title={"CARMA - CLs"} />
            <div>
                <Switch>
                    <Route path={`${match.path}/:id/details`} component={CLDetailsContainer} />
                </Switch>
            </div>
        </div>
    );
};
